export const HTML_INTERACTION_CHANNEL = 'gab-html-interaction-v1';
export const MAX_PREVIEW_STATE = 16384;

// Generated page data is never authority. Reject oversized/deep values and
// prototype keys before retaining anything in the host or drafting a message.
export function readPreviewState(value) {
  try {
    let count = 0;
    const check = (node, depth = 0) => {
      if (++count > 2000 || depth > 10) return false;
      if (node === null || typeof node === 'boolean') return true;
      if (typeof node === 'number') return Number.isFinite(node);
      if (typeof node === 'string') return node.length <= 12000;
      if (!node || typeof node !== 'object') return false;
      return Object.entries(node).every(([key, child]) => !['__proto__', 'prototype', 'constructor'].includes(key) && check(child, depth + 1));
    };
    if (!value || typeof value !== 'object' || Array.isArray(value) || !check(value)) return null;
    const out = { modelContent: value.modelContent ?? null, privateContent: value.privateContent ?? null, presentation: value.presentation ?? {} };
    const json = JSON.stringify(out);
    return json.length <= MAX_PREVIEW_STATE ? JSON.parse(json) : null;
  } catch { return null; }
}
export function readPreviewManifest(value) {
  if (!value || typeof value !== 'object') return null;
  const variants = Array.isArray(value.variants) ? value.variants.filter(v => typeof v === 'string' && v.length <= 80).slice(0, 8) : [];
  const controls = (Array.isArray(value.controls) ? value.controls : []).slice(0, 12).flatMap(c => {
    if (!c || typeof c.id !== 'string' || c.id.length > 100 || typeof c.label !== 'string' || c.label.length > 100) return [];
    if (c.type === 'toggle' && typeof c.value === 'boolean') return [{ id: c.id, label: c.label, type: c.type, value: c.value }];
    if (c.type === 'slider' && [c.min, c.max, c.step, c.value].every(Number.isFinite) && c.min < c.max && c.step > 0 && c.value >= c.min && c.value <= c.max) return [{ id: c.id, label: c.label, type: c.type, min: c.min, max: c.max, step: c.step, value: c.value }];
    if (c.type === 'select' && Array.isArray(c.options) && c.options.length <= 12 && c.options.every(v => typeof v === 'string' && v.length <= 80) && c.options.includes(c.value)) return [{ id: c.id, label: c.label, type: c.type, value: c.value, options: c.options }];
    return [];
  });
  return { variants, selectedVariant: variants.includes(value.selectedVariant) ? value.selectedVariant : variants[0], controls };
}

// Source string works on Hermes too. This API can only report bounded state and
// request a draft; it exposes no tools, cookies, tokens, network or execution.
export const HTML_INTERACTION_RUNTIME = String.raw`function installGabPreview(config) {
  var channel='gab-html-interaction-v1', state=Object.assign({modelContent:null,privateContent:null,presentation:{}},config.state || {}), controls=[], variants=[], group=null;
  state.presentation=state.presentation || {};
  var timer=null;
  function send(type,payload) {
    var data={channel:channel,session:config.session,type:type,payload:payload};
    if(window.ReactNativeWebView)window.ReactNativeWebView.postMessage(JSON.stringify(data));
    else window.parent.postMessage(data,config.parentOrigin || '*');
  }
  function snapshot(){return JSON.parse(JSON.stringify(state));}
  function report(){send('state',snapshot());}
  function manifest(){
    send('manifest',{variants:variants,selectedVariant:state.presentation.variant,controls:controls.filter(function(c){return !c.owner.container || !c.owner.container.closest('[hidden]');}).map(function(c){return Object.assign({},c.spec,{value:c.object[c.key]});})});
  }
  function queue(){if(timer!==null)clearTimeout(timer);timer=setTimeout(function(){timer=null;manifest();},0);}
  function setState(next){
    if(!next || typeof next!=='object')return Promise.resolve(false);
    try{var presentation=Object.assign({},state.presentation), values=Object.assign({},presentation.controls);
      controls.forEach(function(c){if(c.valid(c.object[c.key]))values[c.spec.id]=c.object[c.key];});
      if(controls.length)presentation.controls=values;
      var out={modelContent:next.modelContent==null?null:next.modelContent,privateContent:next.privateContent==null?null:next.privateContent,presentation:presentation};
      if(JSON.stringify(out).length>16384)return Promise.resolve(false);
      state=JSON.parse(JSON.stringify(out));report();queue();return Promise.resolve(true);
    }catch(_){return Promise.resolve(false);}
  }
  function variant(name){
    if(!group || variants.indexOf(name)===-1)return;
    Array.from(group.children).forEach(function(child){var label=child.getAttribute('data-variant') || child.getAttribute('data-gab-variant');if(label)child.hidden=label!==name;});
    state.presentation.variant=name;report();manifest();
  }
  var api={setState:setState,requestFollowUp:function(value){var prompt=typeof value==='string'?value:value&&value.prompt;if(typeof prompt==='string'&&prompt.trim()&&prompt.length<=4000)send('draft',{prompt:prompt.trim()});return Promise.resolve();}};
  Object.defineProperty(api,'state',{get:function(){return snapshot();}});
  window.gab=Object.assign({},window.gab,{preview:api});
  var compat={setWidgetState:setState,sendFollowUpMessage:api.requestFollowUp};
  Object.defineProperty(compat,'widgetState',{get:function(){return snapshot();}});
  if(!window.openai)window.openai=compat;
  function register(owner,object,key,options,type){
    options=options || {};if(controls.length>=12 || !object)return owner;
    var id=String(controls.length)+':'+String(key).slice(0,60), spec={id:id,label:String(options.label || key).slice(0,100),type:type};
    if(type==='slider'){spec.min=Number(options.min);spec.max=Number(options.max);spec.step=Number(options.step || 1);}
    if(type==='select')spec.options=(options.options || []).map(function(o){return typeof o==='string'?o:o.value;}).slice(0,12);
    var saved=state.presentation.controls && state.presentation.controls[id];
    var valid=function(v){return type==='toggle'?typeof v==='boolean':type==='select'?spec.options.indexOf(v)!==-1:typeof v==='number'&&isFinite(v)&&v>=spec.min&&v<=spec.max;};
    if(valid(saved)){object[key]=saved;if(owner.onChange)owner.onChange();}
    controls.push({object:object,key:key,spec:spec,owner:owner,valid:valid});queue();return owner;
  }
  function Tweak(options){this.onChange=options&&options.onChange;this.container=options&&options.container;this.supported=true;}
  Tweak.prototype.addSlider=function(o,k,p){return register(this,o,k,p,'slider');};
  Tweak.prototype.addToggle=function(o,k,p){return register(this,o,k,p,'toggle');};
  Tweak.prototype.addSelect=function(o,k,p){return register(this,o,k,p,'select');};
  Tweak.prototype.dispose=function(){controls=controls.filter(function(c){return c.owner!==this;},this);queue();};
  if(!window.Tweak)window.Tweak=Tweak;
  function receive(data){
    if(!data || data.channel!==channel || data.session!==config.session)return;
    if(data.type==='variant')variant(data.payload);
    if(data.type==='control'){
      var input=data.payload || {}, c=controls.find(function(item){return item.spec.id===input.id;});
      if(!c || !c.valid(input.value))return;c.object[c.key]=input.value;
      state.presentation.controls=state.presentation.controls || {};state.presentation.controls[c.spec.id]=input.value;
      if(c.owner.onChange)c.owner.onChange();report();manifest();
    }
  }
  window.addEventListener('message',function(event){if(event.source===window.parent && (!config.parentOrigin || event.origin===config.parentOrigin))receive(event.data);});
  window.__gabReceivePreview=receive;
  function start(){
    group=document.querySelector('.viz-carousel, [data-gab-variants]');
    if(group){variants=Array.from(group.children).map(function(c){return c.getAttribute('data-variant') || c.getAttribute('data-gab-variant');}).filter(Boolean).slice(0,8);
      if(variants.length)variant(variants.indexOf(state.presentation.variant)!==-1?state.presentation.variant:variants[0]);}
    send('ready',null);manifest();
    window.dispatchEvent(new CustomEvent('gab:preview-ready',{detail:snapshot()}));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
}`;

export function withHtmlInteraction(html, config) {
  const args = JSON.stringify(config).replace(/</g, '\\u003c');
  const index = html.indexOf('>', html.indexOf('<meta http-equiv="Content-Security-Policy"')) + 1;
  return html.slice(0, index) + `<script>(${HTML_INTERACTION_RUNTIME})(${args});</script>` + html.slice(index);
}
export function previewRevision(html) {
  let a = 2166136261, b = 5381;
  for (let i = 0; i < html.length; i += 1) { a = Math.imul(a ^ html.charCodeAt(i), 16777619); b = Math.imul(b, 33) ^ html.charCodeAt(i); }
  return `${html.length}-${(a >>> 0).toString(16)}-${(b >>> 0).toString(16)}`;
}
